// height.service.ts
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HeightService {
  readonly heights = signal<number[]>([84, 95, 108]);

  // Default value is the first height in the list
  readonly selectedHeight = signal<number>(this.heights()[0]);

  setSelectedHeight(height: number): void {
    this.selectedHeight.set(height);
  }
}
